import type * as React from 'react';
import { toast } from 'sonner';

export const sleep = (time = 1000) =>
	new Promise((resolve) => setTimeout(resolve, time));

export function debounce<T extends (...args: any[]) => void>(
	func: T,
	wait = 1000,
): (...args: Parameters<T>) => void {
	let timeout: ReturnType<typeof setTimeout> | undefined;
	return function (this: ThisParameterType<T>, ...args: Parameters<T>): void {
		clearTimeout(timeout);
		timeout = setTimeout(() => func.apply(this, args), wait);
	};
}

export function throttle<T extends (...args: any[]) => void>(
	func: T,
	wait = 1000,
): (...args: Parameters<T>) => void {
	let inThrottle = false;
	return function (this: ThisParameterType<T>, ...args: Parameters<T>): void {
		if (!inThrottle) {
			func.apply(this, args);
			inThrottle = true;
			setTimeout(() => {
				inThrottle = false;
			}, wait);
		}
	};
}

export const generateRandomStars = (count: number) => {
	let result = ''; // Use a single string to avoid array overhead
	for (let i = 0; i < count; i++) {
		// Inline calculations and formatting
		const x = Math.random() * 100;
		const y = Math.random() * 100;
		result += `radial-gradient(circle at ${x}% ${y}%, rgba(95, 150, 172, 0.5) 0.2%, transparent 0%), `;
	}
	return result.slice(0, -2); // Remove the trailing comma and space
};

export function dismissToast(id: string | number) {
	setTimeout(() => toast.dismiss(id), 1000);
}

export function handleChangeWithLimit<
	E extends React.ChangeEvent<HTMLTextAreaElement>,
>(handler: (e: E) => void, options: { limit: number }): (e: E) => void {
	return (e: E) => {
		if (e.target.value.length <= options.limit) {
			handler(e);
		}
	};
}
